import { makeStyles } from '@material-ui/core'
import { colors } from '../../../Themes'

const tableCellStyles = {
  head: {
    backgroundColor: colors.white,
    color: colors.primary,
    fontSize: 18
  },
  body: {
    fontSize: 16,
    color: colors.primary,
    padding: '24px 16px'
  },
}
  
const tableRowStyles = {
  root: {
    backgroundColor: colors.white,
  },
}

const useStylesTable = makeStyles({
  table: {
    minWidth: 700,
  },
  container: {
    marginTop: 25,
    boxShadow: 'none'
  },
  showMore: {
    textAlign: 'center',
    fontSize: 18,
    fontFamily: 'Roboto',
    fontWeight: 'normal',
    color: colors.accent,
    cursor: 'pointer'
  },
  paymentId: {
    color: colors.accent,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  statusPaid: {
    padding: '4px 15px',
    backgroundColor: 'transparent',
    color: '#12C730 !important ',
    border: '1px solid #12C730',
    borderRadius: 22
  },
  statusFailed: {
    padding: '4px 15px',
    backgroundColor: 'transparent',
    color: '#EE4352 !important ',
    border: '1px solid #EE4352',
    borderRadius: 22
  },
  copyBase: {
    textTransform: 'none',
    color: colors.white,
    backgroundColor: colors.white,
    borderRadius: 10,
    flexShrink: 0,
    '&:hover': {
      backgroundColor: colors.grayHover,
    },
  },
  afterCopied: {
    position: 'absolute',
    width: 250,
    top: -20,
  },
  caption: {
    textAlign: 'center'
  },
  margin: {
    marginTop: 32 
  },
  tableFont: {
    fontSize: 18
  }
})

export { tableCellStyles, tableRowStyles, useStylesTable }